/**
 * NEWT FORM Consumer API For Consumer UI
 * NEWT FORM コンシューマ UI からコールされる コンシューマ API です。   
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FormPagePropertyItemFileUploadErrorMessage } from './formPagePropertyItemFileUploadErrorMessage';
import { FormPagePropertyItemFileUploadInputFormat } from './formPagePropertyItemFileUploadInputFormat';
import { FormPagePropertyItemFileUploadFormat } from './formPagePropertyItemFileUploadFormat';
import { FormPagePropertyItemStringConvertRule } from './formPagePropertyItemStringConvertRule';


/**
 * ファイルアップロード項目詳細
 */
export interface FormPagePropertyItemFileUpload { 
    /**
    * フォーム入力項目大種別
    */
    propertyType: 'fileUpload';
    /**
    * 入力項目ID
    */
    propertyId: string;
    /**
    * 項目名(管理機能のopenapiではdisplay_name）
    */
    name: string;
    /**
    * 項目のコメント(管理機能のopenapiではdisplay_comment）
    */
    comment?: string;
    /**
    * 注意書き・凡例(管理機能のopenapiではcaution）
    */
    note?: string;
    /**
    * 必須/任意のラベルを表示するかどうか.
    */
    displayRequiredLabel: boolean;
    stringConvertRule?: FormPagePropertyItemStringConvertRule;
    type: FormPagePropertyItemFileUpload.TypeEnum;
    fileUploadFormat?: FormPagePropertyItemFileUploadFormat;
    inputFormat: FormPagePropertyItemFileUploadInputFormat;
    errorMessage?: FormPagePropertyItemFileUploadErrorMessage;
}

export namespace FormPagePropertyItemFileUpload {
    export type TypeEnum = 'string';
    export const TypeEnum = {
        String: 'string' as TypeEnum
    };
}


